import React, { useEffect, useState } from "react";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import { ThemeProvider, useTheme } from "@aws-amplify/ui-react";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import awsConfig from "../aws-exports.js";

export function LivenessDetector() {
  const [loading, setLoading] = useState(true);
  const [sessionId, setSessionId] = useState(null);

  const credentialsProvider = fromCognitoIdentityPool({
    identityPoolId: awsConfig.identityPoolId,
    clientConfig: { region: awsConfig.region },
  });

  const sendMessage = (data) => {
    window.parent.postMessage(data, "*");
    // 给flutter发消息
    if (window.facedetect) {
      window.facedetect.postMessage(JSON.stringify(data));
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const sessionIdFromQuery = queryParams.get("sessionId");

    if (sessionIdFromQuery) {
      setSessionId(sessionIdFromQuery);
      setLoading(false);
    } else {
      console.error("No sessionId found in query string");
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!loading) {
      sendMessage({
        act: "loaded",
      });
    }

    const observer = new MutationObserver((mutations, obs) => {
      const toastContainer = document.querySelector(
        ".amplify-liveness-toast__container"
      );
      if (toastContainer) {
        // 创建要追加的内容
        const customContent = document.createElement("div");
        customContent.innerHTML = `<div style="color:#111;font-size:14px;text-align:left;">Make sure you're in a well-lit place with a clearly seen face and hold the camera steady. Don't worry, this won't appear on your profile.</div>`;

        // 追加到目标 div
        toastContainer.appendChild(customContent);

        // 找到目标后停止观察
        obs.disconnect();
      }
    });

    // 开始观察整个 body 的子元素变化
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // 清理函数：组件卸载时停止观察
    return () => observer.disconnect();
  }, [loading]);

  const handleAnalysisComplete = () => {
    // 根据返回的结果进行后续处理
    sendMessage({
      act: "complete",
      sessionId: sessionId,
    });
  };

  const { tokens } = useTheme();
  const theme = {
    name: "Face Liveness Example Theme",
    tokens: {
      space: {
        xxxl: "24px",
      },
      colors: {
        background: {
          primary: {
            // value: tokens.colors.neutral["90"].value,
            value: "#FFFAF2",
            // value: "linear-gradient(202deg, #FFFAF2 9%, #FFEBEA 75.62%), #FFF;",
          },
          secondary: {
            value: tokens.colors.neutral["100"].value,
          },
        },
        font: {
          primary: {
            // value: tokens.colors.white.value,
            value: "#FC5C20",
          },
        },
        brand: {
          primary: {
            10: "#FC5C20", // 最浅（用于 hover/active 状态）
            20: "#FC5C20", // 稍浅
            40: "#FC5C20", // 中等
            60: "#FC5C20", // 默认品牌色
            80: "#FC5C20", // 稍深
            90: "#FC5C20", // 更深
            100: "#FC5C20", // 最深（用于 pressed 状态）
          },
        },
        primary: {
          10: "#FC5C20", // 最浅（用于 hover/active 状态）
          20: "#FC5C20", // 稍浅
          40: "#FC5C20", // 中等
          60: "#FC5C20", // 默认品牌色
          80: "#FC5C20", // 稍深
          90: "#FC5C20", // 更深
          100: "#FC5C20", // 最深（用于 pressed 状态）
        },
      },
    },
  };

  return (
    <ThemeProvider theme={theme}>
      {loading ? (
        ""
      ) : (
        <FaceLivenessDetector
          sessionId={sessionId}
          region="us-east-1"
          onAnalysisComplete={handleAnalysisComplete}
          config={{
            credentialProvider: credentialsProvider,
          }}
          onUserCancel={() => {
            sendMessage({
              act: "restart",
            });
          }}
          displayText={{}}
          onError={(error) => {
            console.error(error);
            if (error.state === "CAMERA_ACCESS_ERROR") {
              sendMessage({
                act: "showCameraAccessError",
              });
            }
          }}
          components={{ PhotosensitiveWarning: () => "" }}
        />
      )}
    </ThemeProvider>
  );
}

export default LivenessDetector;
